"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
function generatePayload(values) {
  var payload = {};

  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0) {
      payload[fieldName] = forcedValue;
    }
  }
  var employerPlanMap = {
    have: 'YES',
    "don't have": 'NO'
  };
  var otherIncomeCoveredMap = {
    Yes: 'YES',
    No: 'NO'
  };

  // Start all REQUIRED general fields
  setFieldIfExists('annualEarnedIncome', (0, _utils.parseCurrencyString)(null, values.annualEarnedIncome));
  setFieldIfExists('cashSavings', (0, _utils.parseCurrencyString)(null, values.cashSavings));
  setFieldIfExists('currentAge', (0, _utils.calculateAge)(values.birthDay, values.birthMonth, values.birthYear));
  setFieldIfExists('estimatedMonthlyExpenses', (0, _utils.parseCurrencyString)(null, values.estimatedMonthlyExpenses));
  setFieldIfExists('haveEmployerPlan', employerPlanMap[values.haveEmployerPlan]);
  setFieldIfExists('inflationRate', (0, _utils.convertPercentageToRate)(values.inflationRate));
  setFieldIfExists('interestRate', (0, _utils.convertPercentageToRate)(values.interestRate));
  setFieldIfExists('salaryGrowthRate', (0, _utils.convertPercentageToRate)(values.salaryGrowthRate));
  setFieldIfExists('taxRate', (0, _utils.convertPercentageToRate)(values.taxRate));
  setFieldIfExists('percentOfExpenses', (0, _utils.parseCurrencyString)(null, values.percentOfExpenses));
  setFieldIfExists('percentOfIncomeCovered', (0, _utils.convertPercentageToRate)(values.percentOfIncomeCovered));
  setFieldIfExists('monthlyCap', (0, _utils.parseCurrencyString)(null, values.monthlyCap));
  setFieldIfExists('mutualFundsStocksSavings', (0, _utils.parseCurrencyString)(null, values.mutualFundsStocksSavings));
  setFieldIfExists('numOfYearsCovered', (0, _utils.parseCurrencyString)(null, values.numOfYearsCovered));
  setFieldIfExists('otherAnnualIncome', (0, _utils.parseCurrencyString)(null, values.otherAnnualIncome));
  setFieldIfExists('otherIncomeCovered', otherIncomeCoveredMap[values.otherIncomeCovered]);
  setFieldIfExists('retirementAge', (0, _utils.parseCurrencyString)(null, values.retirementAge));
  setFieldIfExists('retirementSavings', (0, _utils.parseCurrencyString)(null, values.retirementSavings));
  setFieldIfExists('yearsToCover', (0, _utils.parseCurrencyString)(null, values.yearsToCover));
  return payload;
}